<template>
  <div>
    <Accordion
      v-for="(item, sectionIndex) in countryData"
      :key="sectionIndex"
      :full="true"
      :dir-button="true"
      :title="item.title"
    >
      <el-tabs class="report-tabs">
        <el-tab-pane v-for="(tab, index) in item.jurisdictions" :key="index">
          <template #label>
            <div class="country__icon">
              <img
                v-if="tab.iso"
                :src="
                  require(`../../assets/images/flags/${tab.iso.toLowerCase()}.svg`)
                "
                :alt="tab.name"
              />
              <img v-else src="../../assets/icons/i_turkey.svg" alt="" />
            </div>
            <span>{{ tab.name }}</span>
          </template>
          <!-- eslint-disable vue/no-v-html -->
          <div
            v-for="(paragraph, paraIndex) in tab.paragraphs"
            :key="paraIndex"
            v-html="paragraph"
          />
          <!-- eslint-enable vue/no-v-html -->
        </el-tab-pane>
      </el-tabs>
    </Accordion>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "ReportCountry",
  components: {
    Accordion: () => import("../elements/Accordion"),
  },
  props: {
    sections: {
      type: Array,
      default: () => [],
    },
    jurisdictions: {
      type: Array,
      default: () => [],
    },
    chosenJurisdictions: {
      type: Array,
      default: () => [],
    },
    chosenSections: {
      type: Array,
      default: () => [],
    },
  },
  computed: { ...mapState("ReportBuilder", ["countryData"]) },
  created() {
    const sections = this.sections.filter((s) =>
      this.chosenSections.includes(s.name)
    );
    const jurisdictions = this.jurisdictions.filter((s) =>
    this.chosenJurisdictions.some(jurisdiction => jurisdiction.name.toLowerCase().includes(s.name.toLowerCase()))
    );
    let queryParams = sections.map((s) => "filter[tid][]=" + s.tid);
    queryParams = queryParams.concat(
      jurisdictions.map((j) => "filter[jid][]=" + j.value)
    );

    this.$store
      .dispatch("ReportBuilder/getViewData", {
        url: "/report-builder/guide-sections?" + queryParams.join("&"),
      })
      .then(({ data }) => {
        this.$store.commit("ReportBuilder/setData", {
          label: "countryData",
          data,
        });
        const links = [];
        data.forEach((d) => {
          d.jurisdictions.forEach((j) => {
            j.related_guides.forEach((r) => {
              if (!links.some((l) => l.title === r.title)) {
                links.push(r);
              }
            });
          });
        });
        this.$emit("updateSidebarLinks", links);
      })
      .catch((error) => console.error("ERROR:", error));
  },
};
</script>

<style lang="scss">
.el-tabs {
  &__header {
    padding-top: 10px !important;
  }
}
</style>

<style scoped lang="scss">
.el-tabs {
  padding-left: 4rem;
  border-left: 1px dotted gray;

  &__item {
    margin-top: 2rem;
    > span {
      font-weight: 700;
    }

    &.is-active {
      border-bottom: 1px solid red !important;
    }
  }
}
@import "../../assets/styles/helpers/variables";
@import "../../assets/styles/helpers/mixin";

.country__icon {
  height: 2.5rem;
  width: 2.5rem;
  display: inline-block;
  padding-right: 1rem;

  img {
    width: 100%;
  }
}
</style>
